module.exports = __webpack_public_path__ + "static/media/icon_reward.b851a598.png";